import React from 'react';
import PropTypes from 'prop-types';
import capitalize from '../../../stringUtils';
import './RoleAndTitleView.scss';

function RoleAndTitleView({
  name, role, seniority, showEditLink, renderEditLink, employmentType,
}) {
  return (
    <div className="role-title-container">
      <div className="header-container">
        <span className="title">Job Title and Role</span>
        {showEditLink && renderEditLink()}
      </div>
      <div className="role-title-body">
        <div>
          {`Title: ${name}`}
        </div>
        <div>
          {`Role: ${role.length > 0 ? role.join(', ') : 'None'}`}
        </div>
        <div>
          {`Seniority: ${seniority.length > 0 ? seniority.join(', ') : 'None'}`}
        </div>
        <div>
          {`Employment Type: ${capitalize(employmentType)}`}
        </div>
      </div>
    </div>
  );
}

RoleAndTitleView.propTypes = {
  name: PropTypes.string.isRequired,
  role: PropTypes.arrayOf(PropTypes.string).isRequired,
  seniority: PropTypes.arrayOf(PropTypes.string).isRequired,
  employmentType: PropTypes.string.isRequired,
  showEditLink: PropTypes.bool,
  renderEditLink: PropTypes.func,
};

RoleAndTitleView.defaultProps = {
  renderEditLink: () => {},
  showEditLink: false,
};

export default RoleAndTitleView;
